<template>
    <div class="animated fadeIn">
      <div class="viewMode">
        <b-row>
          <b-col cols="12">
            <h1>Vehicle Plate Order</h1>
          </b-col>
        </b-row>
        <b-row v-if="canSelectOtherSites && !createWizardActive">
          <b-col sm="12">
            <b-card>
              <div slot="header">
                  <strong>Select Site</strong>
              </div>
              <b-row>
                <b-col sm="4">
                  <b-form-group>
                    <label for="company">Company</label>
                    <b-form-select id="company" v-if="companiesLoaded"  v-model="filterParams.company_id"
                      :plain="true"
                      :options="companies"
                      :disabled="!isMinimumSuperAdmin || this.basketItemsCount > 0">
                    </b-form-select>
                    <div v-if="!companiesLoaded" >
                      <i class="fa fa-spin fa-spinner"></i>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="area">Area</label>
                    <b-form-select id="area" v-if="areasLoaded"  v-model="filterParams.area_id"
                      :plain="true"
                      :options="areas"
                      :disabled="!isMinimumCompanyUser || this.basketItemsCount > 0">
                    </b-form-select>
                    <div v-if="!areasLoaded" >
                      <i class="fa fa-spin fa-spinner"></i> Waiting for company selection
                    </div>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="site">Site</label>
                    <b-form-select id="site" v-if="sitesLoaded"  v-model="filterParams.site_id"
                      :plain="true"
                      :options="sites"
                      :disabled="!isMinimumAreaUser || this.basketItemsCount > 0">
                    </b-form-select>
                    <div v-if="!sitesLoaded" >
                      <i class="fa fa-spin fa-spinner"></i> Waiting for area selection
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="isMinimumSuperAdmin && !siteChosen">
          <b-col>
            <b-alert class="mt-2" variant="danger" show>
              Waiting for site selection...
            </b-alert>
          </b-col>
        </b-row>
        <b-row v-if="!isDefaultTemplateAvailable && !createWizardActive && siteChosen">
          <b-col>
            <b-alert class="mt-2" variant="danger" v-if="!isMinimumSuperAdmin" show>
              There must be a <strong>default template</strong> available and one has not been found. Please ask your administrator to create one.
            </b-alert>
            <b-alert class="mt- centre-text" variant="danger" v-if="isMinimumSuperAdmin" show>
              There is no default template for this site ({{ siteChosenName }}). If this is a new customer setup, click the <strong>Create Initial Template</strong> button.
              If this is <strong>NOT</strong> a new customer setup, assign an existing template to be a default.
              <p class="mt-3">
                <b-button v-on:click="setupInitialCreateForm()" variant="primary">
                  <i class="fa fa-plus"></i>&nbsp;Create Initial Template
                </b-button>
              </p>
            </b-alert>
          </b-col>
        </b-row>
        <b-row v-if="createWizardActive">
          <b-col>
            <b-card>
              <div slot="header">
                <strong>
                  Initial Template Options
                </strong>
                </div>
                <div class="form-container">
                  <b-row>
                    <b-col sm="4">
                      <b-form-group>
                        <label for="plateTextInput">Trade Customer</label>
                        <b-form-select
                          id="tradeCustomer"
                          v-model="supplierId"
                          :plain="true"
                          :options="suppliers"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group>
                        <label for="plateMessageInput">Slogan</label>
                        <b-form-input
                        v-model="plateProperties.plateMessageInput"
                        type="text"
                        id="plateMessageInput"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group>
                        <label for="platePostCodeInput">Post Code</label>
                          <b-form-input
                            v-model="plateProperties.platePostCodeInput"
                            type="text"
                            id="platePostCodeInput"
                            class="uppercase"
                          ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <b-button v-on:click="createInitialTemplate()" :disabled="cantCreateInitalTemplate" variant="primary">
                        <i class="fa fa-check"></i>&nbsp;Save and Create Template
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
            </b-card>
          </b-col>
        </b-row>
        <div class='main-details-container' v-if="isDefaultTemplateAvailable && siteChosen">
          <b-row class="mb-3 action-button-bar">
            <b-col>
              <b-button v-on:click="gotoBasket()" variant="outline-primary" outline>
                <i class="fa fa-shopping-basket"></i>&nbsp;Basket
                <b-badge variant="warning" :style="{position: 'static'}">{{ basketItemsCount }}</b-badge>
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" v-if="!createWizardActive">
              <b-card>
                <div slot="header">
                  <strong>
                    Plate Details
                  </strong>
                </div>
                <div class="form-container">
                  <b-row>
                    <b-col sm="3">
                      <b-form-group>
                        <label for="plateTextInput">Registration Number</label>
                          <b-form-input
                            v-model="plateProperties.plateTextInput"
                            type="text"
                            class="uppercase"
                            id="plateTextInput"
                            :maxlength="8"
                          ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="4">
                      <b-form-group>
                        <label for="plateMessageInput">Slogan</label>
                        <b-form-input
                        v-model="plateProperties.plateMessageInput"
                        type="text"
                        id="plateMessageInput"
                        :disabled="!isMinimumSuperAdmin"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3">
                      <b-form-group>
                        <label for="platePostCodeInput">Post Code</label>
                          <b-form-input
                            v-model="plateProperties.platePostCodeInput"
                            type="text"
                            id="platePostCodeInput"
                            class="uppercase"
                            :disabled="!isMinimumSuperAdmin"
                          ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="2">
                      <b-form-group>
                        <label for="platePostCodePosition">Position</label>
                        <b-form-select
                          id="platePostCodePosition"
                          v-model="plateProperties.platePostCodePosition"
                          :plain="true"
                          :options="platePostCodePostions"
                          :disabled="!isMinimumSuperAdmin"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4">
                      <b-form-group>
                        <label for="plateSize">Sizes</label>
                        <b-form-select
                          id="plateSize"
                          v-model="plateProperties.plateSelectedSize"
                          :plain="true"
                          :options="plateSizesSelect"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3">
                      <b-form-group>
                        <label for="isPrintMarque">Plates Required</label>
                        <b-form-select
                          id="platesRequired"
                          v-model="plateProperties.platesRequiredSelection"
                          :plain="true"
                          :options="platesRequiredOptions"
                        ></b-form-select>
                      </b-form-group>
                    </b-col> 
                    <b-col sm="2">
                      <b-form-group>
                        <label for="isPrintBorder">Border</label>
                        <br />
                        <b-button 
                          class="btn-block" 
                          variant="outline-primary" 
                          :pressed.sync="plateProperties.isPrintBorder">{{plateProperties.isPrintBorder ? 'On ' : 'Off'}}
                        </b-button>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3">
                      <b-form-group>
                        <label for="isPrintMarque">Flag</label>
                        <b-form-select
                          id="flagSelection"
                          v-model="plateProperties.flagSelection"
                          :plain="true"
                          :options="flagSelectOptions"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </b-card>
            </b-col>
          </b-row>
          <transition name="fade" mode="out-in">
            <div v-show="rearPlateChosen" class="reg-output">
              <b-row>
                <b-col class="dfc" sm="12">
                  <div
                    ref="platePrintAreaOuter"
                    id="platePrintAreaOuter"
                    v-bind:style="platePrintStyleObject"
                  >
                    <div id="plateRenderParent" ref="plateRenderParent" v-bind:style="plateRenderStyle">
                      <div ref="marque" id="marque" v-bind:style="plateMarqueStyle">
                        <div class="flag-container">
                          <img ref="marque-image" id="marque-image" v-bind:style="plateMarqueFlagImageStyle" v-bind:src="plateMarqueFlagImageSrc" />
                          <img ref="marque-image-text" id="marque-image-text" v-bind:style="plateMarqueFlagTextStyle" v-bind:src="plateMarqueFlagTextSrc" />
                        </div>
                      </div>
                      <div ref="platePrintArea" id="platePrintArea" v-bind:style="platePrintAreaStyle">
                        <div v-bind:style="plateRenderSingleLineStyle"
                          ref="plateRender"
                          id="plateRender"
                          v-text="plateProperties.plateTextInput"
                        ></div>
                        <div v-bind:style="plateRenderDoubleLineStyle"
                          ref="plateSquareTextOutputLine1"
                          id="plateSquareTextOutputLine1"
                          v-text="plateSquareTextOutputLine1"
                        >
                        </div>
                        <div v-bind:style="plateRenderDoubleLineStyle"
                          ref="plateSquareTextOutputLine2"
                          id="plateSquareTextOutputLine2"
                          v-text="plateSquareTextOutputLine2"
                        ></div>
                        <div id="plateFooter">
                          <div v-bind:style="plateFooterElementsContainerStyle" 
                            id="plateFooterElementsContainer" 
                            ref="plateFooterElementsContainer">
                            <div
                              v-if="plateProperties.plateMessageInput.length > 0"
                              ref="sloganMessage"
                              id="sloganMessage"
                              v-text="plateProperties.plateMessageInput"
                              v-bind:style="sloganStyle"
                            ></div>
                            <div
                              v-if="plateProperties.platePostCodeInput.length > 0"
                              ref="sloganPostcode"
                              id="sloganPostcode"
                              v-bind:style="postcodeStyle"
                            >
                              <span
                                ref="sloganPostcodeInner"
                                id="sloganPostcodeInner"
                                v-text="plateProperties.platePostCodeInput"
                                v-bind:style="postcodeStyleInner"
                              ></span>
                            </div>
                          </div>
                        </div>
                        <div id="bsauContainer" ref="bsauContainer" v-bind:style="plateBSAUContainerStyle">
                          <div
                            ref="bsau"
                            id="bsau"
                            v-text="'SAP BSAU 145e'"
                            v-bind:style="plateBSAUStyle"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>         
            </div>
          </transition>
          <transition name="fade" mode="out-in">
            <div v-show="frontPlateChosen" class="reg-output-front">
              <b-row>
                <b-col class="dfc" sm="12">
                  <div
                    ref="platePrintAreaOuter"
                    id="platePrintAreaOuter"
                    v-bind:style="platePrintStyleObject"
                  >
                    <div id="plateRenderParent" ref="plateRenderParent" v-bind:style="plateRenderStyle">
                      <div ref="marque" id="marque" v-bind:style="plateMarqueStyle">
                        <div class="flag-container">
                          <img ref="marque-image" id="marque-image" v-bind:style="plateMarqueFlagImageStyle" v-bind:src="plateMarqueFlagImageSrc" />
                          <img ref="marque-image-text" id="marque-image-text" v-bind:style="plateMarqueFlagTextStyle" v-bind:src="plateMarqueFlagTextSrc" />
                        </div>
                      </div>
                      <div ref="platePrintArea" id="platePrintArea" v-bind:style="platePrintAreaStyle">
                        <div v-bind:style="plateRenderSingleLineStyle"
                          ref="plateRender"
                          id="plateRender"
                          v-text="plateProperties.plateTextInput"
                        ></div>
                        <div v-bind:style="plateRenderDoubleLineStyle"
                          ref="plateSquareTextOutputLine1"
                          id="plateSquareTextOutputLine1"
                          v-text="plateSquareTextOutputLine1"
                        >
                        </div>
                        <div v-bind:style="plateRenderDoubleLineStyle"
                          ref="plateSquareTextOutputLine2"
                          id="plateSquareTextOutputLine2"
                          v-text="plateSquareTextOutputLine2"
                        ></div>
                        <div id="plateFooter">
                          <div v-bind:style="plateFooterElementsContainerStyle" 
                            id="plateFooterElementsContainer" 
                            ref="plateFooterElementsContainer">
                            <div
                              v-if="plateProperties.plateMessageInput.length > 0"
                              ref="sloganMessage"
                              id="sloganMessage"
                              v-text="plateProperties.plateMessageInput"
                              v-bind:style="sloganStyle"
                            ></div>
                            <div
                              v-if="plateProperties.platePostCodeInput.length > 0"
                              ref="sloganPostcode"
                              id="sloganPostcode"
                              v-bind:style="postcodeStyle"
                            >
                              <span
                                ref="sloganPostcodeInner"
                                id="sloganPostcodeInner"
                                v-text="plateProperties.platePostCodeInput"
                                v-bind:style="postcodeStyleInner"
                              ></span>
                            </div>
                          </div>
                        </div>
                        <div id="bsauContainer" ref="bsauContainer" v-bind:style="plateBSAUContainerStyle">
                          <div
                            ref="bsau"
                            id="bsau"
                            v-text="'SAP BSAU 145e'"
                            v-bind:style="plateBSAUStyle"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>         
            </div>
          </transition>
          <div class="reg-output-rear-canvas">
            <b-row>
              <b-col class="dfc" sm="12">
                <div
                  ref="platePrintAreaOuter"
                  id="platePrintAreaOuter"
                  v-bind:style="platePrintStyleObject"
                >
                  <div id="plateRenderParent" ref="plateRenderParent" v-bind:style="plateRenderStyle">
                    <div ref="marque" id="marque" v-bind:style="plateMarqueStyle">
                      <div class="flag-container">
                        <img ref="marque-image" id="marque-image" v-bind:style="plateMarqueFlagImageStyle" v-bind:src="plateMarqueFlagImageSrc" />
                        <img ref="marque-image-text" id="marque-image-text" v-bind:style="plateMarqueFlagTextStyle" v-bind:src="plateMarqueFlagTextSrc" />
                      </div>
                    </div>
                    <div ref="platePrintArea" id="platePrintArea" v-bind:style="platePrintAreaStyle">
                      <div v-bind:style="plateRenderSingleLineStyle"
                        ref="plateRender"
                        id="plateRender"
                        v-text="plateProperties.plateTextInput"
                      ></div>
                      <div v-bind:style="plateRenderDoubleLineStyle"
                        ref="plateSquareTextOutputLine1"
                        id="plateSquareTextOutputLine1"
                        v-text="plateSquareTextOutputLine1"
                      >
                      </div>
                      <div v-bind:style="plateRenderDoubleLineStyle"
                        ref="plateSquareTextOutputLine2"
                        id="plateSquareTextOutputLine2"
                        v-text="plateSquareTextOutputLine2"
                      ></div>
                      <div id="plateFooter">
                        <div v-bind:style="plateFooterElementsContainerStyle" 
                          id="plateFooterElementsContainer" 
                          ref="plateFooterElementsContainer">
                          <div
                            v-if="plateProperties.plateMessageInput.length > 0"
                            ref="sloganMessage"
                            id="sloganMessage"
                            v-text="plateProperties.plateMessageInput"
                            v-bind:style="sloganStyle"
                          ></div>
                          <div
                            v-if="plateProperties.platePostCodeInput.length > 0"
                            ref="sloganPostcode"
                            id="sloganPostcode"
                            v-bind:style="postcodeStyle"
                          >
                            <span
                              ref="sloganPostcodeInner"
                              id="sloganPostcodeInner"
                              v-text="plateProperties.platePostCodeInput"
                              v-bind:style="postcodeStyleInner"
                            ></span>
                          </div>
                        </div>
                      </div>
                      <div id="bsauContainer" ref="bsauContainer" v-bind:style="plateBSAUContainerStyle">
                        <div
                          ref="bsau"
                          id="bsau"
                          v-text="'SAP BSAU 145e'"
                          v-bind:style="plateBSAUStyle"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>         
          </div>
          <div class="reg-output-front-canvas">
            <b-row>
              <b-col class="dfc" sm="12">
                <div
                  ref="platePrintAreaOuter"
                  id="platePrintAreaOuter"
                  v-bind:style="platePrintStyleObject"
                >
                  <div id="plateRenderParent" ref="plateRenderParent" v-bind:style="plateRenderStyle">
                    <div ref="marque" id="marque" v-bind:style="plateMarqueStyle">
                      <div class="flag-container">
                        <img ref="marque-image" id="marque-image" v-bind:style="plateMarqueFlagImageStyle" v-bind:src="plateMarqueFlagImageSrc" />
                        <img ref="marque-image-text" id="marque-image-text" v-bind:style="plateMarqueFlagTextStyle" v-bind:src="plateMarqueFlagTextSrc" />
                      </div>
                    </div>
                    <div ref="platePrintArea" id="platePrintArea" v-bind:style="platePrintAreaStyle">
                      <div v-bind:style="plateRenderSingleLineStyle"
                        ref="plateRender"
                        id="plateRender"
                        v-text="plateProperties.plateTextInput"
                      ></div>
                      <div v-bind:style="plateRenderDoubleLineStyle"
                        ref="plateSquareTextOutputLine1"
                        id="plateSquareTextOutputLine1"
                        v-text="plateSquareTextOutputLine1"
                      >
                      </div>
                      <div v-bind:style="plateRenderDoubleLineStyle"
                        ref="plateSquareTextOutputLine2"
                        id="plateSquareTextOutputLine2"
                        v-text="plateSquareTextOutputLine2"
                      ></div>
                      <div id="plateFooter">
                        <div v-bind:style="plateFooterElementsContainerStyle" 
                          id="plateFooterElementsContainer" 
                          ref="plateFooterElementsContainer">
                          <div
                            v-if="plateProperties.plateMessageInput.length > 0"
                            ref="sloganMessage"
                            id="sloganMessage"
                            v-text="plateProperties.plateMessageInput"
                            v-bind:style="sloganStyle"
                          ></div>
                          <div
                            v-if="plateProperties.platePostCodeInput.length > 0"
                            ref="sloganPostcode"
                            id="sloganPostcode"
                            v-bind:style="postcodeStyle"
                          >
                            <span
                              ref="sloganPostcodeInner"
                              id="sloganPostcodeInner"
                              v-text="plateProperties.platePostCodeInput"
                              v-bind:style="postcodeStyleInner"
                            ></span>
                          </div>
                        </div>
                      </div>
                      <div id="bsauContainer" ref="bsauContainer" v-bind:style="plateBSAUContainerStyle">
                        <div
                          ref="bsau"
                          id="bsau"
                          v-text="'SAP BSAU 145e'"
                          v-bind:style="plateBSAUStyle"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>         
          </div>
          <b-row class="order-buttons-row mt-4">
            <b-col>
              <b-button v-on:click="addToBasket" variant="primary">
                <i class="fa fa-shopping-basket"></i>&nbsp;Add to basket
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
</template>

<script>

import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import html2canvas from 'html2canvas';
import MUPService from '@/services/mup-service.js';
import LookupDataService from '@/services/lookup-data-service.js';
import SuppliersService from '@/services/suppliers-service.js';
import { storeController, store } from '../../shared/store';

export default {
  name: 'vehiclePlateOrder',
  components: {
      LoadingSpinner: LoadingSpinner,
  },
  data () {
    return {
      userObj: '',
      supplierId: 0,
      plateProperties: {
        plateTextInput: '',
        plateRaiseInput: 0,
        plateMessageInput: '',
        plateMessageRaiseInput: 0,
        plateMessageOffsetInput: 0,
        plateMessageFontSizeInput: 5,
        plateMessageFont: 'Arial',
        isPlateMessageItalic: false,
        isPlateMessageBold: false,
        platePostCodeInput: '',
        platePostCodeRaiseInput: 0,
        platePostCodePosition: 'Below',
        platePostCodeOffsetInput: 0,
        platePostCodeFontSizeInput: 3,
        platePostCodeFont: 'Arial',
        isPostCodeItalic: false,
        isPostCodeBold: false,
        plateBSAUInput: '',
        plateBSAUPostfix: ' ...',
        plateBSAURaiseInput: 0,
        plateBSAUOffsetInput: 0,
        plateBSAUFontSizeInput: 3,
        isPrintBorder: false,
        plateBorderMargin: 4,
        plateBorderWidth: 2,
        plateBorderColour: '#000000',
        plateBorderGap: 0,
        isPrintMarque: false,
        originalIsPrintMarque: false,
        flagSelection: '',
        plateMarqueWidth: 0,
        plateSelectedSize: 0,
        isPrintBSAU: false,
        plateTextLines: 1,
        plateTextLineGap: 0,
        plateWIPInput: '',
        plateCode: 'trade',
        isPlateShaped: false,
        isAllowMarque: false,
        isMarquePositionAtBottom: false,
        isAllowBorder: false,
        platesRequiredSelection: 'rear'
      },
      conditionalTemplateSettings: {
        plateBSAURaiseInput: 0,
        plateBSAUOffsetInput: 0
      },
      plateSquareTextOutputLine1: '',
      plateSquareTextOutputLine2: '',
      singlePlateAutoSpace: true,
      platePostCodePostions: [
          {value: 'Below', text: 'Below'},
          {value: 'Right', text: 'Right'}
      ],
      sloganStyle: {
          display: 'inline',
          zIndex: '2'
      },
      postcodeStyle: {
          fontFamily: 'Arial',
          fontSize: '3mm',
          zIndex: '0',
          display: 'inline-flex'
      },
      postcodeStyleInner: {
          marginLeft: 0,
      },
      plateRenderStyle: {
          width: '520mm',
          height: '111mm',
          widthActual: 520,
          heightActual: 111,
      },
      plateBSAUStyle: {
          display: 'none',
          fontSize: '4mm'
      },
      plateBSAUContainerStyle: {
        bottom: 0,
        right: 0
      },
      plateMarqueStyle: {
        backgroundColor: '',
        display: '',
        top: '0px',
        bottom: 'inherit',
        borderTopLeftRadius: '30px;',
        height: '111mm'
      },
      plateMarqueFlagImageSrc: '',
      plateMarqueFlagImageStyle: {
        visibility: ''
      },
      plateMarqueFlagTextSrc: '',
      plateMarqueFlagTextStyle: {
        visibility: ''
      },
      flagSelectOptions: [
          {value: 'none', text: 'None'},
      ],
      plateFlags: [],
      platesRequiredOptions: [
          {value: 'rear', text: 'Rear Only'},
          {value: 'front', text: 'Front Only'},
          {value: 'both', text: 'Front &amp; Rear'}
      ],
      platePrintStyleObject: {
          width: '520mm',
          height: '111mm',
          widthActual: 520,
          heightActual: 111,
      },
      plateRenderSingleLineStyle: {
          display: 'block',
          marginTop: '8mm'
      },
      plateRenderDoubleLineStyle: {
          display: 'none'
      },
      plateFooterElementsContainerStyle: {
        paddingLeft: '0mm',
        paddingRight: '0mm'
      },
      platePrintAreaStyle: {
        borderRadius: '30px',
        width: '100%',
        height: '100%'
      },
      isDefaultTemplateAvailable: true,
      isUserSuperAdmin: false,
      userAuthLevel: '',
      filterParams: {
        company_id: -1,
        area_id: -1,
        site_id: -1,
      },
      companies: [],
      areas: [],
      sites: [],
      suppliers: [],
      companiesLoaded: false,
      areasLoaded: false,
      sitesLoaded: false,
      showCreateSection: false,
      createWizardActive: false,
      siteChosen: false,
      siteChosenName: '',
      template: {},
      plateSizes: [],
      plateSizesSelect: [],
      selectedPlateSize: {},
      plateSizesLoaded: false,
      EU_LOGO_WIDTH: 45,
      flagColour: 'blue',
      rearPlateChosen: true,
      frontPlateChosen: false,
      order: {
        empty: true,
        items: []
      }
    }
  },
  async created () {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);

    // get the logged in user
    const userObj = JSON.parse(localStorage.getItem('user'));
    this.$data.userObj = userObj;

    // grab the filter properties for the user
    this.$data.filterParams.company_id = userObj.company_id;
    this.$data.filterParams.area_id = userObj.area_id;
    this.$data.filterParams.site_id = userObj.site_id;
    this.$data.userAuthLevel = userObj.auth;

    // get the initial site name
    const sitesList = await LookupDataService.getSiteList(userObj.area_id);
    this.$data.siteChosenName = sitesList.filter(s => s.value == userObj.site_id)[0].text;
    
    // if we're not super admin, then don't worry about chosing sites and stuff
    // if (userObj.auth != 'Super Admin') {
    //   this.$data.siteChosen = true;
    // }
    // else {
    //   this.$data.siteChosen = false;
    // }

    this.getInitialData();
    this.loadDefaultTemplate();
    
  },
  watch: {
    'filterParams.company_id': async function(val, oldVal) {
      // get the branches for the selected company
      // clear it out first
      this.$data.areas = [];
      this.$data.sites = [];
      this.$data.siteChosenName = '';
      this.$data.isDefaultTemplateAvailable = false;
      this.$data.siteChosen = false;

      const areaList = await LookupDataService.getAreaList(val);
      if (this.$data.userAuthLevel == 'Super Admin' || this.$data.userAuthLevel == 'Company Users') {
        this.$data.areas.push({value:0, text: 'Select Area...'});
        this.$data.filterParams.area_id = 0;
        this.$data.filterParams.site_id = 0;
      }
      areaList.map((item) => {
        this.$data.areas.push(item);
      });
      this.$data.areasLoaded = true;
    },
    'filterParams.area_id': async function(val, oldVal) {
      // clear it out first
      this.$data.sites = [];
      this.$data.sites.push({value:0, text: 'Select Site...'});
      this.$data.filterParams.site_id = 0;

      if (parseInt(val) > 0) {
        const sitesList = await LookupDataService.getSiteList(val);
        sitesList.map((item) => {
          this.$data.sites.push(item);
        });
        this.$data.sitesLoaded = true;
      }
    },
    'filterParams.site_id': function(val, oldVal) {
      this.$data.filterParams.site_id = val;
      try {
        if (val > 0) {
          this.loadDefaultTemplate();
          this.$data.siteChosen = true;
        }
        else {
          this.$data.siteChosen = false;
        }
        this.$data.siteChosenName = this.$data.sites.filter(s => s.value == val)[0].text;
      }
      catch (e) {
        //this.$data.siteChosenName = '';
      }
    },
    'plateProperties.plateTextInput': function(val, oldVal) {
      this.$data.plateProperties.plateTextInput = val.toUpperCase();
      if (this.$data.selectedPlateSize.lines == 2) {
        if (val.length == 4) {
          if (val.indexOf(' ') == -1) {
            val = val + ' ';
            this.$data.plateProperties.plateTextInput = val;
          }
        }
        else if (val.length > 4) {
          this.$data.plateProperties.plateTextInput = this.$data.plateProperties.plateTextInput.replace('  ', ' ');
        }
        this.$data.plateSquareTextOutputLine1 = this.$data.plateProperties.plateTextInput.substring(0, this.$data.plateProperties.plateTextInput.indexOf(" "));
        this.$data.plateSquareTextOutputLine2 = this.$data.plateProperties.plateTextInput.substring(this.$data.plateProperties.plateTextInput.indexOf(" ") + 1);
      }
      if (this.$data.singlePlateAutoSpace) {
        if (val.length == 7) {
          if (val.indexOf(' ') == -1) {
            this.$data.plateProperties.plateTextInput = val.substr(0, val.length - 3) + " " + val.substr(-3);
          }
        }
      }
    },
    'plateProperties.isPrintBorder': function(val, oldVal) {
      // update the 'original' value
      //this.$data.plateProperties.originalIsPrintBorder = val;
      let isBorder = val;
      let borderStyle = '';
      const borderWidth = this.$data.plateProperties.plateBorderWidth;
      const borderMarginWidth = this.$data.plateProperties.plateBorderMargin;
      const platePrintAreaDiv = document.getElementById('platePrintArea');
      const platePrintAreaDivFront = document.querySelector('.reg-output-front #platePrintArea');

      let blockWidth = 0;
      let blockWidthCSS = '';

      blockWidth = this.$data.platePrintStyleObject.widthActual - this.$data.EU_LOGO_WIDTH;
      if (this.$data.plateProperties.isPrintMarque) {
        let reduceBy = (parseInt(this.$data.plateProperties.plateBorderMargin) * 2);
        blockWidth -= reduceBy;
        blockWidthCSS = blockWidth.toString() + "mm";
      }
      else {
        blockWidthCSS = "100%";
      }
      //blockWidthCSSCanvas = blockWidthCSS;
      this.$data.platePrintAreaStyle.width = blockWidthCSS;
      // platePrintAreaDiv.style.width = blockWidthCSS;
      // platePrintAreaDivFront.style.width = blockWidthCSS;

      if (isBorder) {
        borderStyle = "solid";
        this.$data.plateProperties.plateRaiseInput = parseInt(this.$data.plateProperties.plateRaiseInput) + parseInt(borderWidth) + parseInt(borderMarginWidth);
      }
      else {
        borderStyle = "none";
        this.$data.plateProperties.plateRaiseInput = parseInt(this.$data.plateProperties.plateRaiseInput) - parseInt(borderWidth) - parseInt(borderMarginWidth);
      }

      this.$data.platePrintAreaStyle.borderStyle = borderStyle;
      // platePrintAreaDiv.style.borderStyle = borderStyle;
      // platePrintAreaDivFront.style.borderStyle = borderStyle;

      this.setPlateBorderMargin(borderMarginWidth, borderMarginWidth);
      this.setPlateBorderWidth(borderWidth, borderWidth);
      this.$data.plateProperties.plateBorderWidth = borderWidth;

      // const marqueVal = this.$data.plateProperties.isPrintMarque;
      // this.$data.plateProperties.isPrintMarque = -1;
      // this.$data.plateProperties.isPrintMarque = marqueVal;

      //this.setMarque(marqueVal, 0);
    },
    'plateProperties.plateBorderGap': function(val, oldVal) {
      // wrap in try block to stop errors before elements have rendered to view
      // console.log('border gap');
      // try {
      //   let gapVal = parseInt(val);
      //   // let borderGapDiv = document.getElementById('plateFooterElementsContainer');
      //   // let borderGapDivFront = document.querySelector('.reg-output-front #plateFooterElementsContainer');

      //   // borderGapDiv.style.paddingLeft = gapVal.toString() + "mm";
      //   // borderGapDiv.style.paddingRight = gapVal.toString() + "mm";
      //   // borderGapDivFront.style.paddingLeft = gapVal.toString() + "mm";
      //   // borderGapDivFront.style.paddingRight = gapVal.toString() + "mm";

      //   this.plateFooterElementsContainerStyle.paddingLeft = gapVal.toString() + "mm";
      //   this.plateFooterElementsContainerStyle.paddingRight = gapVal.toString() + "mm";

      // }
      // catch (e) {
      //   console.log("Initial elements render");
      // }
      let gapVal = parseInt(val);
      this.plateFooterElementsContainerStyle.paddingLeft = gapVal.toString() + "mm";
      this.plateFooterElementsContainerStyle.paddingRight = gapVal.toString() + "mm";
    },
    'plateProperties.plateRaiseInput': function(val, oldVal) {
        let raiseVal = parseInt(val);

        try {

          let plateRenderDiv = document.querySelector('.reg-output #plateRender');
          let plateRenderDivFront = document.querySelector('.reg-output-front #plateRender');

          let plateSquareTextOutputLine1Div = document.getElementById('plateSquareTextOutputLine1');
          let plateSquareTextOutputLine1DivFront = document.querySelector('.reg-output-front #plateSquareTextOutputLine1');

          if (this.$data.selectedPlateSize.lines != 2) {
            if (raiseVal < 0) {
              this.plateRenderSingleLineStyle.marginTop = Math.abs(raiseVal).toString() + "mm";
              // plateRenderDiv.style.marginTop = Math.abs(raiseVal).toString() + "mm";
              // plateRenderDivFront.style.marginTop = Math.abs(raiseVal).toString() + "mm";
            }
            else {
              this.plateRenderSingleLineStyle.marginTop = "-" + raiseVal.toString() + "mm";
              // plateRenderDiv.style.marginTop = "-" + raiseVal.toString() + "mm";
              // plateRenderDivFront.style.marginTop = "-" + raiseVal.toString() + "mm";
            }
          }
          else {
            if (parseInt(this.$data.selectedPlateSize.is_motorcycle) == 0) {
              if (raiseVal < 0) {
                plateSquareTextOutputLine1Div.style.marginTop = Math.abs(raiseVal).toString() + "mm";
                plateSquareTextOutputLine1DivFront.style.marginTop = Math.abs(raiseVal).toString() + "mm";
              }
              else {
                plateSquareTextOutputLine1Div.style.marginTop = "-" + raiseVal.toString() + "mm";
                plateSquareTextOutputLine1DivFront.style.marginTop = "-" + raiseVal.toString() + "mm";
              }
            }
            else {
              if (raiseVal < 0) {
                plateSquareTextOutputLine1Div.style.marginTop = (Math.abs(raiseVal) + 7).toString() + "mm";
                plateSquareTextOutputLine1DivFront.style.marginTop = (Math.abs(raiseVal) + 7).toString() + "mm";
              }
              else {
                plateSquareTextOutputLine1Div.style.marginTop = (7 - raiseVal).toString() + "mm";
                plateSquareTextOutputLine1DivFront.style.marginTop = (7 - raiseVal).toString() + "mm";
              }
            }
          }
        }
        catch (e) {
          console.log('Initial elements render');
        }
    },
    'plateProperties.platePostCodePosition': function(val, oldVal) {
      if (val =='Right') {
        this.$data.sloganStyle.display = 'inline-flex';
        this.$data.postcodeStyle.display = 'inline-flex';
        this.$data.plateProperties.platePostCodeOffsetInput = 2;
      }
      else {
        this.$data.sloganStyle.display = 'inline-flex';
        this.$data.postcodeStyle.display = 'block';
        this.$data.plateProperties.platePostCodeOffsetInput = 0;
      }
    },
    'plateProperties.platePostCodeOffsetInput': function(val, oldVal) {
        let raiseVal = parseInt(val);
        this.$data.postcodeStyleInner.marginLeft = raiseVal.toString() + "mm";
    },
    'plateProperties.plateMessageFontSizeInput': function(val, oldVal) {
      // wrap in try block to stop errors before elements have rendered to view
      try {
        let raiseVal = parseInt(val);
        this.$data.sloganStyle.fontSize = raiseVal.toString() + "mm";
        //var sloganMessageDiv = document.getElementById('sloganMessage');
        //sloganMessageDiv.style.fontSize = raiseVal.toString() + "mm";
        //this.sloganStyle.fontSize = raiseVal.toString() + "mm";
      }
      catch (e) {
        console.log("Initial elements render");
      }
    },
    'plateProperties.plateSelectedSize': function(val, oldVal) {
      const raiseRegVal = this.$data.plateProperties.plateRaiseInput;

      console.log(document.querySelector('.reg-output #plateRender'));
      
      try {
        let selectedPlate = this.$data.plateSizes.filter(item => {
          return parseInt(item.id) === parseInt(val);
        })[0];

        if (selectedPlate){

          this.$data.platePrintStyleObject.width = parseInt(selectedPlate.width_in_mm) + 'mm';
          this.$data.platePrintStyleObject.height = parseInt(selectedPlate.height_in_mm) + 'mm';
          this.$data.platePrintStyleObject.widthActual = parseInt(selectedPlate.width_in_mm);
          this.$data.platePrintStyleObject.heightActual = parseInt(selectedPlate.height_in_mm);

          this.$data.plateRenderStyle.width = parseInt(selectedPlate.width_in_mm) + 'mm';
          this.$data.plateRenderStyle.height = parseInt(selectedPlate.height_in_mm) + 'mm';
          this.$data.plateRenderStyle.widthActual = parseInt(selectedPlate.width_in_mm);
          this.$data.plateRenderStyle.heightActual = parseInt(selectedPlate.height_in_mm);;

          let platePrintRender = document.querySelector('.reg-output #plateRender');
          let platePrintRenderFront = document.querySelector('.reg-output-front #plateRender');
          let platePrintRenderRearCanvas = document.querySelector('.reg-output-rear-canvas #plateRender');
          let platePrintRenderFrontCanvas = document.querySelector('.reg-output-front-canvas #plateRender');

          let plateSquareTextOutputLine1 = document.querySelector('.reg-output #plateSquareTextOutputLine1');
          let plateSquareTextOutputLine2 = document.querySelector('.reg-output #plateSquareTextOutputLine2');
          let plateSquareTextOutputLine1Front = document.querySelector('.reg-output-front #plateSquareTextOutputLine1');
          let plateSquareTextOutputLine2Front = document.querySelector('.reg-output-front #plateSquareTextOutputLine2');
          let plateSquareTextOutputLine1RearCanvas = document.querySelector('.reg-output-rear-canvas #plateSquareTextOutputLine1');
          let plateSquareTextOutputLine2RearCanvas = document.querySelector('.reg-output-rear-canvas #plateSquareTextOutputLine2');
          let plateSquareTextOutputLine1FrontCanvas = document.querySelector('.reg-output-front-canvas #plateSquareTextOutputLine1');
          let plateSquareTextOutputLine2FrontCanvas = document.querySelector('.reg-output-front-canvas #plateSquareTextOutputLine2');

          // change the line spacing if needed
          this.$data.platePrinterAmountOfLines = selectedPlate.lines;
          this.$data.selectedPlateSize = selectedPlate;

          if (selectedPlate.allow_marque == 0) {
            this.$data.plateProperties.isPrintMarque = 0;
            this.$data.plateProperties.flagSelection = 'none';
          }
          else {
            if (this.$data.plateProperties.originalIsPrintMarque == 1) {
              this.$data.plateProperties.isPrintMarque = 1;
              this.$data.plateProperties.flagSelection = this.$data.plateProperties.originalFlagSelection;
            }
          }

          if (selectedPlate.is_lipped == 0) {
            this.$data.plateProperties.isLipped = false;
          }
          else {
            if (selectedPlate.is_lipped == 1) {
              this.$data.plateProperties.isLipped = true;
            }
          }

          if (selectedPlate.lines == 2) {
            this.$data.plateRenderSingleLineStyle.display = 'none';
            this.$data.plateRenderDoubleLineStyle.display = 'block';
            // split the reg and put it on both lines
            this.$data.plateSquareTextOutputLine1 = this.$data.plateProperties.plateTextInput.substring(0, this.$data.plateProperties.plateTextInput.indexOf(" "));
            this.$data.plateSquareTextOutputLine2 = this.$data.plateProperties.plateTextInput.substring(this.$data.plateProperties.plateTextInput.indexOf(" ") + 1);

            if (parseInt(selectedPlate.is_motorcycle) == 0) {
              plateSquareTextOutputLine1.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 79) + "mm";
              plateSquareTextOutputLine1Front.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 79) + "mm";
              plateSquareTextOutputLine1RearCanvas.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 79) + "mm";
              plateSquareTextOutputLine1FrontCanvas.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 79) + "mm";

              plateSquareTextOutputLine2.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 79) + "mm";
              plateSquareTextOutputLine2Front.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 79) + "mm";
              plateSquareTextOutputLine2RearCanvas.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 79) + "mm";
              plateSquareTextOutputLine2FrontCanvas.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 79) + "mm";
            }
            else {
              plateSquareTextOutputLine1.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 64) + "mm";
              plateSquareTextOutputLine1Front.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 64) + "mm";
              plateSquareTextOutputLine1RearCanvas.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 64) + "mm";
              plateSquareTextOutputLine1FrontCanvas.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 64) + "mm";

              plateSquareTextOutputLine2.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 64) + "mm";
              plateSquareTextOutputLine2Front.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 64) + "mm";
              plateSquareTextOutputLine2RearCanvas.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 64) + "mm";
              plateSquareTextOutputLine2FrontCanvas.style.lineHeight = (parseInt(selectedPlate.lines_gap) + 64) + "mm";

              if (raiseRegVal < 0) {
                plateSquareTextOutputLine1.style.marginTop = (Math.abs(raiseRegVal) + 7).toString() + "mm";
                plateSquareTextOutputLine1Front.style.marginTop = (Math.abs(raiseRegVal) + 7).toString() + "mm";
                plateSquareTextOutputLine1RearCanvas.style.marginTop = (Math.abs(raiseRegVal) + 7).toString() + "mm";
                plateSquareTextOutputLine1FrontCanvas.style.marginTop = (Math.abs(raiseRegVal) + 7).toString() + "mm";
              }
              else {
                plateSquareTextOutputLine1.style.marginTop = (7 - raiseRegVal).toString() + "mm";
                plateSquareTextOutputLine1Front.style.marginTop = (7 - raiseRegVal).toString() + "mm";
                plateSquareTextOutputLine1RearCanvas.style.marginTop = (7 - raiseRegVal).toString() + "mm";
                plateSquareTextOutputLine1FrontCanvas.style.marginTop = (7 - raiseRegVal).toString() + "mm";
              }
              
            }
          }
          else {
            this.$data.plateRenderDoubleLineStyle.display = 'none';
            this.$data.plateRenderSingleLineStyle.display = 'block';

            platePrintRender.style.lineHeight = 0.857;
            platePrintRenderFront.style.lineHeight = 0.857;
            platePrintRenderRearCanvas.style.lineHeight = 0.857;
            platePrintRenderFrontCanvas.style.lineHeight = 0.857;
          }
          this.setPlateBorderMargin(this.$data.plateProperties.plateBorderMargin, this.$data.plateProperties.plateBorderMargin);
          window.dispatchEvent(new Event('resize'));

          this.$data.plateProperties.plateRaiseInput = parseInt(selectedPlate.reg_raise);

          //check if we're dealing with a shaped plate or not..
          if (parseInt(selectedPlate.is_shaped) == 1) {
            this.$data.plateProperties.plateBSAURaiseInput = selectedPlate.bsau_raise_by;
            this.$data.plateProperties.plateBSAUOffsetInput = selectedPlate.bsau_offset_by;
          }
          else {
            this.$data.plateProperties.plateBSAURaiseInput = this.$data.conditionalTemplateSettings.plateBSAURaiseInput;
            this.$data.plateProperties.plateBSAUOffsetInput = this.$data.conditionalTemplateSettings.plateBSAUOffsetInput;
          }

          // is it a motorcycle plate?
          if (parseInt(selectedPlate.is_motorcycle) == 1) {
            // apply the new class
            plateSquareTextOutputLine1.classList.add('motorcycle');
            plateSquareTextOutputLine1Front.classList.add('motorcycle');
            plateSquareTextOutputLine1RearCanvas.classList.add('motorcycle');
            plateSquareTextOutputLine1FrontCanvas.classList.add('motorcycle');

            plateSquareTextOutputLine2.classList.add('motorcycle');
            plateSquareTextOutputLine2Front.classList.add('motorcycle');
            plateSquareTextOutputLine2RearCanvas.classList.add('motorcycle');
            plateSquareTextOutputLine2FrontCanvas.classList.add('motorcycle');
          }
          else {
            plateSquareTextOutputLine1.classList.remove('motorcycle');
            plateSquareTextOutputLine1Front.classList.remove('motorcycle');
            plateSquareTextOutputLine1RearCanvas.classList.remove('motorcycle');
            plateSquareTextOutputLine1FrontCanvas.classList.remove('motorcycle');

            plateSquareTextOutputLine2.classList.remove('motorcycle');
            plateSquareTextOutputLine2Front.classList.remove('motorcycle');
            plateSquareTextOutputLine2RearCanvas.classList.remove('motorcycle');
            plateSquareTextOutputLine2FrontCanvas.classList.remove('motorcycle');
          }

        }
        
        this.resetFlag();
      }
      catch (e) {
        // initial elements render
      }

    },
    'plateProperties.plateMessageRaiseInput': function(val, oldVal) {
      // wrap in try block to stop errors before elements have rendered to view
      try {
        let raiseVal = parseInt(val);
        this.$data.sloganStyle.bottom = raiseVal.toString() + "mm";
      }
      catch (e) {
        console.log("Initial elements render");
      }
    },
    'plateProperties.platePostCodeRaiseInput': function(val, oldVal) {
        let raiseVal = parseInt(val);
        this.$data.postcodeStyle.bottom = raiseVal.toString() + "mm";
    },
    'plateProperties.plateBSAURaiseInput': function(val, oldVal) {
      let raiseVal = parseInt(val);
      this.$data.plateBSAUContainerStyle.bottom = raiseVal.toString() + "mm";
    },
    'plateProperties.plateBSAUOffsetInput': function(val, oldVal) {
      let raiseVal = parseInt(val);
      this.$data.plateBSAUContainerStyle.right = raiseVal.toString() + "mm";
    },
    'plateProperties.plateBSAUFontSizeInput': function(val, oldVal) {
      let raiseVal = parseInt(val);
      this.$data.plateBSAUStyle.fontSize = raiseVal.toString() + "mm";
    },
    'plateProperties.isPrintBSAU': function(val, oldVal) {
      if (val == 0) {
        this.$data.plateBSAUStyle.display = 'none';
      }
      else {
        this.$data.plateBSAUStyle.display = 'block';
      }
    },
    'flagColour': function(val, oldVal) {
      
      // get the flag details so we can set the bits
      const selectedFlag = this.$data.plateFlags.filter(flag => flag.ref_code == val)[0];
      this.plateMarqueStyle.backgroundColor = selectedFlag.colour;
      // marqueDiv.style.backgroundColor = selectedFlag.colour;
      // marqueDivFront.style.backgroundColor = selectedFlag.colour;

      if (selectedFlag.flag_image_file != 'none') {
        this.plateMarqueFlagImageSrc = '/flags/' + selectedFlag.flag_image_file;
        this.plateMarqueFlagTextSrc = '/flags/' + selectedFlag.flag_image_text_file;
        this.plateMarqueFlagImageStyle.visibility = 'visible';
        this.plateMarqueFlagTextStyle.visibility = 'visible';
      }
      else {
        this.plateMarqueFlagImageStyle.visibility = 'hidden';
        this.plateMarqueFlagTextStyle.visibility = 'hidden';
      }
      
    },
    'plateProperties.flagSelection': function(val,oldVal) {
      if (val == 'none') {
        this.$data.plateProperties.isPrintMarque = 0;
      }
      else {
        this.$data.flagColour = val;
        this.$data.plateProperties.isPrintMarque = 1;
      }
    },
    'plateProperties.isPrintMarque': function(val, oldVal) {
      // update the 'original' value
      //this.$data.plateProperties.originalIsPrintMarque = val;
      
      try {
        let isMarque = parseInt(val);
        let displayVal = "";
        let floatVal = "";
        let blockWidth = 0;
        let blockWidthCSS = '';
        let platePrintAreaDiv = document.querySelector('.reg-output #platePrintArea');
        let platePrintAreaDivFront = document.querySelector('.reg-output-front #platePrintArea');
        let platePrintAreaDivFrontCanvas = document.querySelector('.reg-output-front-canvas #platePrintArea');
        let plateSquareTextOutputLine1 = document.querySelector('.reg-output #plateSquareTextOutputLine1');
        let plateSquareTextOutputLine1Front = document.querySelector('.reg-output-front #plateSquareTextOutputLine1');

        // do a reseet first
        displayVal = "none";
        floatVal = "none";
        blockWidthCSS = "100%";
        plateSquareTextOutputLine1.style.marginLeft = 'inherit';
        plateSquareTextOutputLine1Front.style.marginLeft = 'inherit';

        // platePrintAreaDiv.style.float = floatVal;
        // platePrintAreaDivFront.style.float = floatVal;
        // platePrintAreaDivFrontCanvas.style.float = floatVal;
        // platePrintAreaDiv.style.width = blockWidthCSS;
        // platePrintAreaDivFront.style.width = blockWidthCSS;
        // platePrintAreaDivFrontCanvas.style.width = floatVal;
        this.platePrintAreaStyle.float = floatVal;
        this.platePrintAreaStyle.width = blockWidthCSS;
        this.plateMarqueStyle.display = displayVal;
        

        // after reset, do it for real
        if (isMarque) {
          displayVal = "block";
          floatVal = "right";
          blockWidth = this.$data.platePrintStyleObject.widthActual - this.$data.EU_LOGO_WIDTH;
          if (this.$data.plateProperties.isPrintBorder) {
              let reduceBy = (parseInt(this.$data.plateProperties.plateBorderMargin) * 2);// - (parseInt(this.$data.plateProperties.plateBorderWidth) * 2);
              blockWidth -= reduceBy;
          }
          blockWidthCSS = blockWidth.toString() + "mm";

          // if the marque is only on the bottom then we need to set that up
          if (this.$data.selectedPlateSize.lines == 2) {
            if (this.$data.selectedPlateSize.marque_position_at_bottom == 1) {
              this.plateMarqueStyle.top = 'inherit';
              this.plateMarqueStyle.bottom = '0';
              this.plateMarqueStyle.borderTopLeftRadius = '0';
              this.plateMarqueStyle.height = parseInt(this.$data.selectedPlateSize.height_in_mm / 2) + 'mm';

              plateSquareTextOutputLine1.style.marginLeft = '-45mm';

              this.plateMarqueStyle.top = 'inherit';
              this.plateMarqueStyle.bottom = '0';
              this.plateMarqueStyle.borderTopLeftRadius = '0';
              this.plateMarqueStyle.height = parseInt(this.$data.selectedPlateSize.height_in_mm / 2) + 'mm';

              plateSquareTextOutputLine1Front.style.marginLeft = '-45mm';
            }
            else {
              plateSquareTextOutputLine1.style.marginLeft = 'inherit';
              plateSquareTextOutputLine1Front.style.marginLeft = 'inherit';
            }
          }
          else {
            this.plateMarqueStyle.top = '0';
            this.plateMarqueStyle.bottom = 'inherit';
            this.plateMarqueStyle.borderTopLeftRadius = '30px';
            this.plateMarqueStyle.height = parseInt(this.$data.selectedPlateSize.height_in_mm) + 'mm';

          }
        }
        else {
          displayVal = "none";
          floatVal = "none";
          blockWidthCSS = "100%";
          plateSquareTextOutputLine1.style.marginLeft = 'inherit';
          plateSquareTextOutputLine1Front.style.marginLeft = 'inherit';
        }

        // platePrintAreaDiv.style.float = floatVal;
        // platePrintAreaDivFront.style.float = floatVal;
        // platePrintAreaDivFrontCanvas.style.float = floatVal;
        // platePrintAreaDiv.style.width = blockWidthCSS;
        // platePrintAreaDivFront.style.width = blockWidthCSS;
        // platePrintAreaDivFrontCanvas.style.width = floatVal;
        this.platePrintAreaStyle.float = floatVal;
        this.platePrintAreaStyle.width = blockWidthCSS;
        this.plateMarqueStyle.display = displayVal;

      }
      catch (e) {
        // initial elements render
      }

    },
    'plateProperties.platesRequiredSelection': function(val, oldVal) {
      if (val == 'rear') {
        this.$data.frontPlateChosen = false;
        this.$data.rearPlateChosen = true;
      }
      if (val == 'front') {
        this.$data.rearPlateChosen = false; 
        this.$data.frontPlateChosen = true;
      }
      if (val == 'both') {
        this.$data.rearPlateChosen = true;
        this.$data.frontPlateChosen = true;
      }
      setTimeout(() => {        
        window.dispatchEvent(new Event('resize'));
      }, 10);
    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.resizePlateOutput);
    });
  },
  computed: {
    isMinimumSuperAdmin() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      
      return returnVal;
    },
    isMinimumCompanyUser() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      return returnVal;
    },
    isMinimumAreaUser() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Area Users':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      return returnVal;
    },
    isMinimumSiteUser() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Area Users':
        case 'Site Users':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      
      return returnVal;
    },
    cantCreateInitalTemplate() {
      let returnVal = false;
      
      if (this.$data.plateProperties.plateMessageInput.length < 1) {
        returnVal = true;
      }

      if (this.$data.plateProperties.platePostCodeInput.length < 1) {
        returnVal = true;
      }

      if (this.$data.supplierId < 1) {
        returnVal = true;
      }
      
      return returnVal;
    },
    canSelectOtherSites() {
      let returnVal = false;
      
      if (
        this.$data.userObj.auth == 'Super Admin' || this.$data.userObj.auth == 'Company Users' ||
        this.$data.userObj.auth == 'Area Users' || this.$data.userObj.auth == 'Site Users'
        ) {
        returnVal = true;
      }
      
      return returnVal;
    },
    basketItemsCount() {
      try {
        return store.mupBasket.items.length;
      }
      catch(e) {
        return 0;
      }
      
    }
  },
  methods : {
    async getInitialData() {
      const companies = await LookupDataService.getCompaniesList();
      this.$data.companies = companies;
      this.$data.companiesLoaded = true;

      const flags = await MUPService.getFlags();
      this.$data.plateFlags = flags;
      // now do the dropdown list
      flags.forEach(flag => {
        this.$data.flagSelectOptions.push({value: flag.ref_code, text: flag.name});
      });
    },
    resizePlateOutput() {
      let areaOuterOffsetWidth = 0;
      let areaOuterOffsetWidthFront = 0;
      let platePrintOuterArea = document.getElementById('platePrintAreaOuter');
      let platePrintOuterAreaFront = document.querySelector('.reg-output-front #platePrintAreaOuter');

      // if nothing has been loaded then don't bother resizing anything
      if (!this.$data.isDefaultTemplateAvailable) {
        return;
      }
      
      try {

        if (platePrintOuterArea.offsetWidth)
        {
          areaOuterOffsetWidth = platePrintOuterArea.offsetWidth + 75;
        }

        if (platePrintOuterAreaFront.offsetWidth)
        {
          areaOuterOffsetWidthFront = platePrintOuterAreaFront.offsetWidth + 75;
        }

        let width = areaOuterOffsetWidth;
        let height = platePrintOuterArea.offsetHeight;

        let widthFront = areaOuterOffsetWidthFront;
        let heightFront = platePrintOuterAreaFront.offsetHeight

        var windowWidth = document.getElementById('main-container').offsetWidth;
        var windowHeight = document.getElementById('main-container').offsetHeight;
        let plateZoom = 1;
        let plateZoomFront = 1;

        plateZoom = Math.min(windowWidth / width, windowHeight / height);
        if (plateZoom > 0.9) {
          plateZoom = 0.9 - (plateZoom - 0.9);
          if (plateZoom < 0.75) {
            plateZoom = 0.75;
          }
        }
        plateZoomFront = Math.min(windowWidth / widthFront, windowHeight / heightFront);
        if (plateZoomFront > 0.9) {
          plateZoomFront = 0.9 - (plateZoomFront - 0.9);
          if (plateZoomFront < 0.75) {
            plateZoomFront = 0.75;
          }
        }
        //console.log(r);
        //platePrintOuterArea.style.transform = 'scale(' + r + ')';
        platePrintOuterArea.style.zoom = plateZoom;
        platePrintOuterAreaFront.style.zoom = plateZoomFront;
      }
      catch (e) {
        // just need to ignore it
      }

    },
    setPlateBorderMargin(val, oldVal) {
      let borderMarginVal = parseInt(val);
      let borderMargin = '';
      let platePrintAreaWidth = 0;
      let platePrintRenderParentDiv = document.getElementById('plateRenderParent');
      let platePrintRenderParentDivFront = document.querySelector('.reg-output-front #plateRenderParent');

      if (this.$data.plateProperties.isPrintBorder) {
        if (borderMarginVal > 0) {
          borderMargin = borderMarginVal.toString() + "mm";
          platePrintAreaWidth = this.$data.platePrintStyleObject.widthActual - (borderMarginVal * 2);
          const marqueVal = this.$data.plateProperties.isPrintMarque;
          if (marqueVal == 1) {
            platePrintAreaWidth -= this.$data.EU_LOGO_WIDTH;
          }
        }
        else {
          borderMargin = "0mm";
        }
      }

      // platePrintRenderParentDiv.style.padding = borderMargin;
      // platePrintRenderParentDivFront.style.padding = borderMargin;
      this.$data.plateRenderStyle.padding = borderMargin;
    },
    setPlateBorderWidth(val, oldVal) {
      let borderWidthVal = parseInt(val);
      let borderWidth = '';
      let platePrintAreaDiv = document.getElementById('platePrintArea');
      let platePrintAreaDivFront = document.querySelector('.reg-output-front #platePrintArea');

      if (borderWidthVal > 0) {
        borderWidth = borderWidthVal.toString() + "mm";
      }
      else {
        borderWidth = "0mm";
      }

      // platePrintAreaDiv.style.borderWidth = borderWidth;
      // platePrintAreaDivFront.style.borderWidth = borderWidth;
      this.$data.platePrintAreaStyle.borderWidth = borderWidth;
    },
    resetFlag() {
      let isMarque = parseInt(this.$data.plateProperties.isPrintMarque);
      let displayVal = "";
      let floatVal = "";
      let floatValCanvas = "";
      let blockWidth = 0;
      let blockWidthCSS = '';
      let blockWidthCSSCanvas = '';
      var platePrintAreaDiv = document.getElementById('platePrintArea');
      var plateSquareTextOutputLine1 = document.getElementById('plateSquareTextOutputLine1');
      //var plateSquareTextOutputLine1Canvas = document.getElementById('plateSquareTextOutputLine1Canvas');

      // do a reseet first
      displayVal = "none";
      floatVal = "none";
      //floatValCanvas  = "none";
      blockWidthCSS = "100%";
      //blockWidthCSSCanvas = "100%";
      plateSquareTextOutputLine1.style.marginLeft = 'inherit';
      //plateSquareTextOutputLine2Canvas.style.marginLeft = 'inherit';

      this.platePrintAreaStyle.float = floatVal;
      this.platePrintAreaStyle.width = blockWidthCSS;
      // platePrintAreaDiv.style.float = floatVal;
      // platePrintAreaDiv.style.width = blockWidthCSS;
      this.plateMarqueStyle.display = displayVal;
      //marqueDiv.style.display = displayVal;

      // don't forget about the canvas for the print
      //var platePrintAreaDivCanvas = document.getElementById('platePrintAreaCanvas');

      //platePrintAreaDivCanvas.style.float = floatValCanvas;
      //platePrintAreaDivCanvas.style.width = blockWidthCSSCanvas;

      // after reset, do it for real
      if (isMarque) {
        displayVal = "block";
        floatVal = "right";
        //floatValCanvas = "right";
        blockWidth = this.$data.platePrintStyleObject.widthActual - this.$data.EU_LOGO_WIDTH;
        if (this.$data.plateProperties.isPrintBorder) {
            let reduceBy = (parseInt(this.$data.plateProperties.plateBorderMargin) * 2);// - (parseInt(this.$data.plateProperties.plateBorderWidth) * 2);
            blockWidth -= reduceBy;
        }
        blockWidthCSS = blockWidth.toString() + "mm";
        //blockWidthCSSCanvas = blockWidthCSS;

        // if the marque is only on the bottom then we need to set that up
        if (this.$data.selectedPlateSize.lines == 2) {
          floatValCanvas = "none";
          //blockWidthCSSCanvas = "100%";
          if (this.$data.selectedPlateSize.marque_position_at_bottom == 1) {
            this.plateMarqueStyle.top = 'inherit';
            this.plateMarqueStyle.bottom = '0';
            this.plateMarqueStyle.borderTopLeftRadius = '0';
            this.plateMarqueStyle.height = parseInt(this.$data.selectedPlateSize.height_in_mm / 2) + 'mm';

            plateSquareTextOutputLine1.style.marginLeft = '-45mm';
            //plateSquareTextOutputLine2Canvas.style.marginLeft = '45mm';
          }
          else {
            plateSquareTextOutputLine1.style.marginLeft = 'inherit';
            //plateSquareTextOutputLine1Canvas.style.marginLeft = 'inherit';
            //plateSquareTextOutputLine2Canvas.style.marginLeft = 'inherit';
            this.plateMarqueStyle.height = parseInt(this.$data.selectedPlateSize.height_in_mm) + 'mm';
            this.plateMarqueStyle.borderTopLeftRadius = '30px';
          }
        }
        else {
          this.plateMarqueStyle.top = '0';
          this.plateMarqueStyle.bottom = 'inherit';
          this.plateMarqueStyle.borderTopLeftRadius = '30px';
          this.plateMarqueStyle.height = parseInt(this.$data.selectedPlateSize.height_in_mm) + 'mm';
        }
      }
      else {
        displayVal = "none";
        floatVal = "none";
        //floatValCanvas  = "none";
        blockWidthCSS = "100%";
        //blockWidthCSSCanvas = "100%";
        plateSquareTextOutputLine1.style.marginLeft = 'inherit';
        //plateSquareTextOutputLine2Canvas.style.marginLeft = 'inherit';
      }

      // platePrintAreaDiv.style.float = floatVal;
      // platePrintAreaDiv.style.width = blockWidthCSS;
      this.platePrintAreaStyle.float = floatVal;
      this.platePrintAreaStyle.width = blockWidthCSS;
      this.plateMarqueStyle.display = displayVal;

    },
    async loadDefaultTemplate() {
      // check we have a default template to load
      // if we have one, load it, if we don't we need to do some work
      const defaultTemplate = await MUPService.getDefaultTemplate(this.$data.filterParams.site_id);
      if (defaultTemplate == null) {
        // We don't have a default template
        this.$data.isDefaultTemplateAvailable = false;
        // if we're a super admin, then allow the first template to be created
        if (this.$data.userObj.auth == 'Super Admin') {
          this.$data.isUserSuperAdmin = true;
        }
      }
      else {
        // load the template
        this.$data.isDefaultTemplateAvailable = true;
        this.$data.siteChosen = true;
        this.$data.template = defaultTemplate;
        this.$data.supplierId = defaultTemplate.supplier_id;

        this.populateViewFromTemplate();
        
        setTimeout(() => {
          this.resizePlateOutput();
        }, 100);

      }
    },
    async createTemplate() {
      // create the new default template
      const isCreated = await MUPService.createTemplate(this.$data.template);
    },
    async populateViewFromTemplate() {
      const template = this.$data.template;

      this.$data.plateProperties.plateMessageInput = template.slogan;
      //this.$data.plateProperties.plateMessageRaiseInput = template.
      this.$data.plateProperties.plateMessageOffsetInput = template.slogan_offset_by
      this.$data.plateProperties.plateMessageFontSizeInput = template.slogan_font_size;
      this.$data.plateProperties.plateMessageFont = template.slogan_font;
      this.$data.plateProperties.isPlateMessageItalic = template.slogan_font_italic == 1 ? true : false;
      this.$data.plateProperties.isPlateMessageBold = template.slogan_font_bold == 1 ? true : false;
      this.$data.plateProperties.platePostCodeInput = template.postcode;
      this.$data.plateProperties.platePostCodeRaiseInput = template.postcode_raise_by;
      this.$data.plateProperties.platePostCodePosition = template.postcode_position;
      this.$data.plateProperties.platePostCodeOffsetInput = template.postcode_offset_by;
      this.$data.plateProperties.platePostCodeFontSizeInput = template.postcode_font_size;
      this.$data.plateProperties.platePostCodeFont = template.postcode_font;
      this.$data.plateProperties.isPostCodeItalic = template.postcode_font_italic == 1 ? true : false;
      this.$data.plateProperties.isPostCodeBold = template.postcode_font_bold == 1 ? true : false;
      this.$data.plateProperties.isPrintBorder = template.is_border == 1 ? true : false;
      this.$data.plateProperties.plateBorderMargin = template.border_margin;
      this.$data.plateProperties.plateBorderWidth = template.border_width;
      this.$data.plateProperties.plateBorderGap = template.border_gap;
      this.$data.plateProperties.plateSelectedSize = template.mup_plate_size;
      this.$data.plateProperties.plateRaiseInput = -6;
      this.$data.plateProperties.plateMessageRaiseInput = template.slogan_raise_by;
      this.$data.plateProperties.platePostCodeRaiseInput = template.postcode_raise_by;
      this.$data.plateProperties.isPrintBSAU = template.is_bsau_mark == 1 ? true : false;
      this.$data.plateProperties.plateBSAURaiseInput = template.bsau_raise_by;
      this.$data.plateProperties.plateBSAUOffsetInput = template.bsau_offset_by;
      this.$data.plateProperties.plateBSAUFontSizeInput = template.bsau_font_size;
      this.$data.plateProperties.isPrintMarque = template.is_marque == 1 ? true : false;
      this.$data.plateProperties.originalIsPrintMarque = template.is_marque;
      this.$data.plateProperties.flagSelection = template.flag_colour;
      this.$data.plateProperties.originalFlagSelection = template.flag_colour;

      this.$data.conditionalTemplateSettings.plateBSAURaiseInput = template.bsau_raise_by;
      this.$data.conditionalTemplateSettings.plateBSAUOffsetInput = template.bsau_offset_by;
      

      // now get the plate sizes
      this.$data.plateSizes = await MUPService.getCurrentPlateSizes(template.id);

      // first set the selectedPlateSize object
      this.$data.selectedPlateSize = this.$data.plateSizes.filter(item => {
        return parseInt(item.id) === parseInt(template.mup_plate_size);
      })[0];

      // now do the select list
      this.$data.plateSizesSelect = this.$data.plateSizes.map((item) => {
        let plate = {
          value: item.id,
          text: item.plate_size_name + ' (' + parseInt(item.width_in_mm) + 'mm x' + parseInt(item.height_in_mm) + 'mm)'
        };
        return plate;
      });
      
      this.$data.plateSizesLoaded = true;
    },
    async setupInitialCreateForm() {
      //this.$data.showCreateSection = true;
      this.$data.createWizardActive = true;
      const suppliers = await SuppliersService.getSuppliers(this.$data.filterParams.company_id);
      this.$data.suppliers = suppliers.map((supplier) => {
        return {
          value: supplier.id, 
          text: supplier.supplier_name
        }
      });
    },
    async createInitialTemplate() {

      let site_id = this.$data.userObj.site_id;
      let area_id = this.$data.userObj.area_id;
      let company_id = this.$data.userObj.company_id;

      if (this.$data.userObj.auth == 'Super Admin') {
        company_id = this.$data.filterParams.company_id;
        area_id = this.$data.filterParams.area_id;
        site_id = this.$data.filterParams.site_id;
      }

      const template = {
        company_id: company_id,
        area_id: area_id,
        site_id: site_id,
        template_name: this.$data.siteChosenName,
        supplier_id: this.$data.supplierId,
        is_default: 1,
        plate_height: 111,
        plate_width: 520,
        slogan: this.$data.plateProperties.plateMessageInput,
        slogan_font: 'Arial',
        slogan_font_bold: 0,
        slogan_font_italic: 0,
        slogan_font_size: 6,
        slogan_offset_by: 0,
        postcode: this.$data.plateProperties.platePostCodeInput,
        postcode_font: 'Arial',
        postcode_position: 'Right',
        postcode_font_size: 3,
        postcode_font_italic: 0,
        postcode_font_bold: 0,
        postcode_offset_by: 0,
        is_border: 0,
        border_width: 2,
        border_margin: 4,
        border_gap: 2,
      }

      this.$data.template = template;
      
      // create the new default template
      await MUPService.createTemplate(this.$data.template);
      this.$data.createWizardActive = false;
      this.loadDefaultTemplate();
      
    },
    resetForm() {
      this.$data.plateProperties.plateTextInput = '';
      this.$data.plateProperties.platePostCodeInput = this.$data.template.postcode;
      this.$data.plateProperties.platePostCodePosition = this.$data.template.postcode_position;
      this.$data.plateProperties.isPrintBorder = this.$data.template.is_border == 1 ? true : false;
      this.$data.plateProperties.plateSelectedSize = this.$data.template.mup_plate_size;
      this.$data.plateProperties.plateRaiseInput = -6;
      this.$data.plateProperties.isPrintMarque = this.$data.template.is_marque == 1 ? true : false;
      this.$data.plateProperties.flagSelection = this.$data.template.flag_colour;

      this.$data.order = {
        empty: true,
        items: []
      };
    },
    async addToBasket() {
      // first, create a new order if it's not already created
      if (this.$data.order.empty) {
        this.$data.order = {
          company_id: this.$data.filterParams.company_id,
          area_id: this.$data.filterParams.area_id,
          site_id: this.$data.filterParams.site_id,
          supplier_id: this.$data.supplierId,
          ordered_by: this.$data.userObj.id,
          order_number: 0,
          shipment: '',
          empty: false,
          items: []
        };
      }

      // build the order item(s)
      let orderItem = {
        company_id: this.$data.filterParams.company_id,
        area_id: this.$data.filterParams.area_id,
        site_id: this.$data.filterParams.site_id, 
        mup_template_id: this.template.id,
        wip_number: 0,
        registration_number: this.$data.plateProperties.plateTextInput,
        plate_type: '',
        supplier_id: this.$data.supplierId,
        plate_height: this.$data.selectedPlateSize.height_in_mm,
        plate_width: this.$data.selectedPlateSize.width_in_mm,
        slogan: this.$data.plateProperties.plateMessageInput,
        slogan_font: this.$data.template.slogan_font,
        slogan_font_size: this.$data.template.slogan_font_size,
        slogan_font_bold: this.$data.template.slogan_font_bold,
        slogan_font_italic: this.$data.template.slogan_font_italic,
        slogan_offset_by: this.$data.template.slogan_offset_by,
        postcode: this.$data.plateProperties.platePostCodeInput,
        postcode_font: this.$data.template.postcode_font,
        postcode_position: this.$data.plateProperties.platePostCodePosition,
        postcode_font_size: this.$data.template.postcode_font_size,
        postcode_font_italic: this.$data.template.postcode_font_italic,
        postcode_font_bold: this.$data.template.postcode_font_bold,
        postcode_offset_by: this.$data.template.postcode_offset_by,
        is_border: this.$data.plateProperties.isPrintBorder,
        border_width: this.$data.template.border_width,
        border_margin: this.$data.template.border_margin,
        border_gap: this.$data.template.border_gap,
        is_bsau_mark: this.$data.template.is_bsau_mark,
        is_marque: this.$data.plateProperties.isPrintMarque,
        flag_colour: this.$data.plateProperties.flagSelection,
        ordered_by: this.$data.userObj.id,
        ordered_by_name: this.$data.userObj.first_name + ' ' + this.$data.userObj.last_name
      }

      const regImageRear = await this.createRegImageForBasket('rear');
      const regImageFront = await this.createRegImageForBasket('front');

      if (this.$data.rearPlateChosen) {
        let rearPlateOrderItem = JSON.parse(JSON.stringify(orderItem));
        rearPlateOrderItem.plate_type = 'rear';
        rearPlateOrderItem.image = regImageRear;
        this.$data.order.items.push(rearPlateOrderItem);
      }
      if (this.$data.frontPlateChosen) {          
        let frontPlateOrderItem = JSON.parse(JSON.stringify(orderItem));
        frontPlateOrderItem.plate_type = 'front';
        frontPlateOrderItem.image = regImageFront;
        this.$data.order.items.push(frontPlateOrderItem);
      }

      // now add the order to the basket if the items were successful
      if (this.$data.order.items.length > 0) {
        // grab the existing basket and add the items to it
        const basket = store.mupBasket;
        if (basket.items !== undefined && !basket.empty) {
          this.$data.order.items.forEach((orderItem) => {
            basket.items.push(orderItem);
          });
          storeController.setMUPBasket(basket);
        }
        else {
          storeController.setMUPBasket(this.$data.order);
        }
        
        // now clear the form ready for the next bits
        this.resetForm();
      }

    },
    async createRegImageForBasket(position) {
      return new Promise(async (resolve, reject) => {
        
        let printElement = document.querySelector('.reg-output-front-canvas #platePrintAreaOuter');
        if (position == 'rear') {
          printElement = document.querySelector('.reg-output-rear-canvas #platePrintAreaOuter');
        }
        
        const printOptions = {
          scale: 1,
          backgroundColor: "rgba(0,0,0,0)"
        };

        let canvas = await html2canvas(printElement, printOptions);

        //try to create an off-dom canvas for a smaller image
        const offdomCanvas = document.createElement('canvas');
        offdomCanvas.width = canvas.width / 4;
        offdomCanvas.height = canvas.height / 4;
        let ctx = offdomCanvas.getContext('2d');
        ctx.drawImage(canvas, 0, 0, canvas.width / 4, canvas.height / 4);
        const imageData = offdomCanvas.toDataURL();

        resolve(imageData);
      });
      
    },
    gotoBasket() {
      window.removeEventListener('resize', this.resizePlateOutput);
      this.$router.push('/vehicle-plate-order-basket');
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: "Charles";
  src: url("~/fonts/SAPUK.TTF") format("truetype");
}
@font-face {
  font-family: "SAPMotorcycle";
  src: url("~/fonts/SAPMotorcycle.ttf") format("truetype");
}
div.reg-output-front-canvas,
div.reg-output-rear-canvas {
  position: absolute;
  top: -1200px;
  left: -5000px;
  /* top: 2000px;
  left: 320px; */
}
/* div.reg-output-front-canvas {
  top: 3000px;
} */
.action-button-bar {
  text-align: right;
}
.order-buttons-row {
  padding-bottom: 50px;
}
.order-buttons-row .col {
  text-align: right;
}
div.reg-output-front {
  margin-top: 20px;
}
h6 {
  text-decoration: underline;
  margin-top: 0.5rem;
}
p.button-area button {
  margin-right: 0.5rem;
}
div.dfc { 
  display: flex;
  justify-content: center;
}
div.reg-output div#platePrintAreaOuter,
div.reg-output-rear-canvas div#platePrintAreaOuter,
div.reg-output-front div#platePrintAreaOuter,
div.reg-output-front-canvas div#platePrintAreaOuter {
  border-radius: 30px;
  display: inline-block;
  background-color: rgb(247, 209, 74);
  transform-origin: top center;
  text-align: center;
  overflow: visible;
  transform: scale(1);
}
div.reg-output-front div#platePrintAreaOuter,
div.reg-output-front-canvas div#platePrintAreaOuter {
  background-color: white;
}

div.reg-output div#platePrintArea,
div.reg-output-rear-canvas div#platePrintArea,
div.reg-output-front div#platePrintArea,
div.reg-output-front-canvas div#platePrintArea {
  border-radius: 30px;
  width: 100%;
  height: 100%;
}
div.reg-output div#marque, 
div.reg-output-rear-canvas div#marque,
div.reg-output-front div#marque,
div.reg-output-front-canvas div#marque {
  float: left;
  width: 45mm;
  text-align: center;
  padding: 4mm;
  background-color: blue;
  /*background: linear-gradient(68deg, blue 50%, green 50%);*/
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  height: 111mm;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 0;
  display: none;
}
div.reg-output div#marque img, 
div.reg-output-front div#marque img,
div.reg-output-front-canvas div#marque img {
  /* float: left; */
  width: 100%;
  /* display: block; */
}
div.reg-output div#marque img#marque-image, 
div.reg-output-rear-canvas div#marque img#marque-image,
div.reg-output-front div#marque img#marque-image,
div.reg-output-front-canvas div#marque img#marque-image {
  align-self: center;
  margin-bottom: 60px;
  width: 140px;
}
div.reg-output div#marque img#marque-image-text, 
div.reg-output-rear-canvas div#marque img#marque-image-text, 
div.reg-output-front div#marque img#marque-image-text,
div.reg-output-front-canvas div#marque img#marque-image-text {
  width: 82%;
  align-self: center;
}
div.flag-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
div.reg-output div#marque span#marque-slogan, 
div.reg-output-rear-canvas div#marque span#marque-slogan,
div.reg-output-front div#marque span#marque-slogan,
div.reg-output-front-canvas div#marque span#marque-slogan {
  display: inline-block;
  position: inherit;
  text-transform: uppercase;
  font-family: "Charles";
  font-size: 25mm;
  color: rgb(247, 209, 74);
  position: relative;
  padding-top: 8mm;
}
div.reg-output-front div#marque span#marque-slogan,
div.reg-output-front-canvas div#marque span#marque-slogan {
  color: white;
}

div.reg-output div#platePrintArea div#plateRender, 
div.reg-output-rear-canvas div#platePrintArea div#plateRender,
div.reg-output-front div#platePrintArea div#plateRender,
div.reg-output-front-canvas div#platePrintArea div#plateRender {
  font-size: 98mm;
  display: inline-block;
  line-height: 0.857;
  text-transform: uppercase;
  font-family: "Charles";
  height: 100%;
  text-align: center;
}
div.reg-output div#platePrintArea div#plateRender.motorcycle {
  font-size: 64mm;
  display: inline-block;
  line-height: 0.857;
  text-transform: uppercase;
  font-family: "SAPMotorcycle";
  height: 100%;
  text-align: center;
}
div.reg-output div#platePrintArea div#plateSquareTextOutputLine1,
div.reg-output-rear-canvas div#platePrintArea div#plateSquareTextOutputLine1,
div.reg-output-front div#platePrintArea div#plateSquareTextOutputLine1,
div.reg-output-front-canvas div#platePrintArea div#plateSquareTextOutputLine1 {
  font-size: 98mm;
  display: inline-block;
  line-height: 0.857;
  text-transform: uppercase;
  font-family: "Charles";
  text-align: center;
}
div.reg-output div#platePrintArea div#plateSquareTextOutputLine1.motorcycle,
div.reg-output-rear-canvas div#platePrintArea div#plateSquareTextOutputLine1.motorcycle {
  font-size: 64mm;
  display: inline-block;
  line-height: 0.857;
  text-transform: uppercase;
  font-family: "SAPMotorcycle";
  text-align: center;
}
div.reg-output div#platePrintArea div#plateSquareTextOutputLine2,
div.reg-output-rear-canvas div#platePrintArea div#plateSquareTextOutputLine2,
div.reg-output-front div#platePrintArea div#plateSquareTextOutputLine2,
div.reg-output-front-canvas div#platePrintArea div#plateSquareTextOutputLine2 {
  font-size: 98mm;
  display: inline-block;
  line-height: 0.857;
  text-transform: uppercase;
  font-family: "Charles";
  text-align: center;
}
div.reg-output div#platePrintArea div#plateSquareTextOutputLine2.motorcycle,
div.reg-output-rear-canvas div#platePrintArea div#plateSquareTextOutputLine2.motorcycle {
  font-size: 64mm;
  display: inline-block;
  line-height: 0.857;
  text-transform: uppercase;
  font-family: "SAPMotorcycle";
  text-align: center;
}
div.reg-output div#platePrintArea div.slogan, 
div.reg-output-rear-canvas div#platePrintArea div.slogan,
div.reg-output-front div#platePrintArea div.slogan,
div.reg-output-front-canvas div#platePrintArea div.slogan {
  line-height: 1;
  font-size: 7mm;
  color: black;
  z-index: 1000;
  background-color: rgb(247, 209, 74);
}
div.reg-output-front div#platePrintArea div.slogan,
div.reg-output-front-canvas div#platePrintArea div.slogan {
  background-color: white;
}

div.reg-output div#platePrintArea div#plateFooter, 
div.reg-output-rear-canvas div#platePrintArea div#plateFooter,
div.reg-output-front div#platePrintArea div#plateFooter,
div.reg-output-front-canvas div#platePrintArea div#plateFooter {
  position: absolute;
  /*display: flex;*/
  left: 0;
  right: 0;
  width: max-content;
  margin: auto;
  bottom: 0mm;
  padding-left: 2mm;
  padding-right: 2mm;
}
div.reg-output div#platePrintArea div#sloganMessage, div.reg-output div#platePrintArea div#sloganMessage2,
div.reg-output-rear-canvas div#platePrintArea div#sloganMessage, div.reg-output-rear-canvas div#platePrintArea div#sloganMessage2,
div.reg-output-front div#platePrintArea div#sloganMessage, div.reg-output-front div#platePrintArea div#sloganMessage2,
div.reg-output-front-canvas div#platePrintArea div#sloganMessage, div.reg-output-front-canvas div#platePrintArea div#sloganMessage2 {
  width: max-content;
  position: relative;
  color: black;
  background-color: rgb(247, 209, 74);
  line-height: 0.9;
}
div.reg-output-front div#platePrintArea div#sloganMessage, div.reg-output-front div#platePrintArea div#sloganMessage2,
div.reg-output-front-canvas div#platePrintArea div#sloganMessage, div.reg-output-front-canvas div#platePrintArea div#sloganMessage2 {
  background-color: white;
}

div.reg-output div#platePrintArea div#sloganPostcode, 
div.reg-output-rear-canvas div#platePrintArea div#sloganPostcode,
div.reg-output-front div#platePrintArea div#sloganPostcode,
div.reg-output-front-canvas div#platePrintArea div#sloganPostcode {
  position: relative;
  left: 0;
  right: 0;
  width: max-content;
  margin: auto;
  bottom: 0mm;
  background-color: rgb(247, 209, 74);
  line-height: 0.9;
}
div.reg-output-front div#platePrintArea div#sloganPostcode,
div.reg-output-front-canvas div#platePrintArea div#sloganPostcode {
  background-color: white;
}

div.reg-output div#platePrintArea div#plateFooter div#plateFooterElementsContainer,
div.reg-output-rear-canvas div#platePrintArea div#plateFooter div#plateFooterElementsContainer,
div.reg-output-front div#platePrintArea div#plateFooter div#plateFooterElementsContainer {
  background-color: rgb(247, 209, 74);
  height: auto;
  padding-top: 2mm;
}
div.reg-output-front div#platePrintArea div#plateFooter div#plateFooterElementsContainer,
div.reg-output-front-canvas div#platePrintArea div#plateFooter div#plateFooterElementsContainer {
  background-color: white;
}

div.reg-output div#platePrintArea div#bsauContainer,
div.reg-output-rear-canvas div#platePrintArea div#bsauContainer,
div.reg-output-front div#platePrintArea div#bsauContainer,
div.reg-output-front-canvas div#platePrintArea div#bsauContainer {
  position: absolute;
  height: auto;
  right: 11mm;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  padding-left: 1mm;
  padding-right: 1mm;
  background-color: rgb(247, 209, 74);
}
div.reg-output-front div#platePrintArea div#bsauContainer,
div.reg-output-front-canvas div#platePrintArea div#bsauContainer {
  background-color: white;
}
div.reg-output div#platePrintArea div#bsau, 
div.reg-output-rear-canvas div#platePrintArea div#bsau, 
div.reg-output-front div#platePrintArea div#bsau,
div.reg-output-front-canvas div#platePrintArea div#bsau {
  position: relative;
  /* right: 11mm; */
  width: max-content;
  /* bottom: 1mm; */
  /* padding-left: 1mm;
  padding-right: 1mm; */
  background-color: rgb(247, 209, 74);
  font-weight: bold;
  color: black;
  line-height: 0.9;
}
div.reg-output-front div#platePrintArea div#bsau,
div.reg-output-front-canvas div#platePrintArea div#bsau {
  background-color: white;
}

div.reg-output div#platePrintArea div#plateArtwork {
  width: 100%;
  left: 0px;
  justify-content: center;
  display: flex;
}

/********************************************************/
p.toolbar button {
  margin-right: 5px;
}
.toolbar-template-name {
  text-align: right;
}
span.template-name {
  font-weight: bold;
}
.uppercase {
  text-transform: uppercase;
}
div.barcode-container svg {
  min-width: 100%;
}
span.upload-switch {
  cursor: pointer;
}
.image-upload-hidden {
  display: none;
}
div.reg-header-options {
  float: right;
}
div.reg-country-options {
  float: inherit;
  display: inline;
  margin-left: 3px;
}
div.batch-manual-import {
  float: inherit;
  display: inline;
  margin-left: 8px;
}
div.reg-header-options fieldset {
  display: inline;
}
div.reg-header-options fieldset legend {
  display: none;
}
div.reg-header-options fieldset.form-group {
  margin-bottom: 0;
}
.modal-button-align-right {
  text-align: right;
}
.batch-print-reg-rows {
  margin-bottom: 2px;
}
div.batchPrintingRowsContainer {
  overflow-x: hidden;
  height: 500px;
  margin-bottom: 15px;
}
div.batchPrintingRowsContainer div.row {
  margin-left: 0px;
  margin-right: 0px;
}
div.batchPrintingHeaderRow {
  margin-bottom: 5px;
}
.modal-header {
    color: #fff;
    background-color: #f7d14a;
    border-color: #b39015;
}

b-card, div.card {
  margin-bottom: 1rem;
}

div#plateTypeOption {
  padding-bottom: 14px;
}

div.custom-control.custom-radio label.custom-control-label.flag-type {
    width: 15px;
    height: 20px;
}
div.custom-control.custom-radio label.custom-control-label.flag-type.flag-normal {
  background: blue;
  border: 1px solid blue;
}
div.custom-control.custom-radio label.custom-control-label.flag-type.flag-electric {
  background: green;
  border: 1px solid green;
}
div.custom-control.custom-radio label.custom-control-label.flag-type.flag-none {
  border: 1px solid silver;
}

</style>
